/**
 * SessionManager - listens for session expiry events.
 * Token refresh and expiry warning UX are handled by AuthProvider.
 */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SESSION_EXPIRED_EVENT } from "../../../utils/sessionLogout";

const SessionManager: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleSessionExpired = () => {
      navigate("/", { replace: true });
    };

    window.addEventListener(
      SESSION_EXPIRED_EVENT,
      handleSessionExpired as EventListener
    );

    return () => {
      window.removeEventListener(
        SESSION_EXPIRED_EVENT,
        handleSessionExpired as EventListener
      );
    };
  }, [navigate]);

  return null;
};

export default SessionManager;

